import React from 'react'
//  const ServerAddress = "http://newtrackingbe.quickindialogistics.com/";
 const ServerAddress = process.env.Backend_Uri;
//  const ServerAddress = "http://192.168.1.40:8000/";


export default ServerAddress;